import FadedOneLineText from './FadedOneLineText';

export default FadedOneLineText;
